import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import GoldenBg from 'assets/golden-bg.webp'

export const StyledFooter = styled.footer`
  margin: 0 0 3rem;
  padding: 0 0 3rem;
  font-size: 1rem;
  text-align: center;
  line-height: 1.42;

  ${mq.medium} {
    margin-top: 5rem;
  }

  &::before {
    content: '';
    display: block;
    height: 1px;
    margin: 0 calc(-1 * var(--container-spacing)) 3rem;
    opacity: 0.7;
    background: url(${GoldenBg}) center center / cover no-repeat;
  }

  dl {
    text-align: left;
    display: grid;
    grid-template-columns: auto auto;
    justify-content: center;
    text-align: left;
    hyphens: manual;
    width: 100%;
    margin: 0;

    div {
      display: contents;
    }

    dd {
      text-align: right;
    }
  }

  ${mq.medium} {
    font-size: 1.4rem;

    dl {
      grid-template-columns: 1fr 1fr;
      gap: 0 calc(var(--gap-size) + 2 * var(--grid-size));
      padding: 0 calc(var(--gap-size) + var(--grid-size));

      div {
        display: flex;
        justify-content: space-between;
        margin: 0.5rem 0;
      }
    }
  }

  ${mq.large} {
    margin-top: 10rem;

    dl {
      grid-template-columns: 1fr 1fr 1fr;
      gap: 0 calc(var(--gap-size) + var(--grid-size));

      dt,
      dd {
        margin: 0;
      }

      dt {
        width: 50%;
      }
    }

    p {
      padding: 0 calc(var(--gap-size) + var(--grid-size));
    }
  }
`

export const Title = styled.h2`
  margin: 2.4rem 0 2rem;
  font-size: 2rem;

  ${mq.medium} {
    font-size: 2.4rem;
  }

  &:not(:first-child)::before {
    content: '';
    display: block;
    margin: 2rem auto;
    width: 3rem;
    height: 3rem;
    background: url(${GoldenBg}) center center / cover no-repeat;
    clip-path: path(
      'M31 15.4992L25.1917 17.4625C21.5517 18.693 18.6946 21.5502 17.464
        25.1901L15.5008 30.9984L13.5375 25.1901C12.307 21.5502 9.44983 18.693
        5.80986 17.4625L0 15.4992L5.80829 13.536C9.44826 12.3054 12.3054 9.44826
        13.536 5.80829L15.4992 0L17.4625 5.80829C18.693 9.44826 21.5502 12.3054
        25.1901 13.536L30.9984 15.4992H31Z'
    );
  }
`
